import { render, staticRenderFns } from "./fee-budgets.vue?vue&type=template&id=68256abc&"
import script from "./fee-budgets.vue?vue&type=script&lang=ts&"
export * from "./fee-budgets.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports